import {useState} from "react";
import styled from 'styled-components/macro';

import {
    Button,
    FormControl,
    FormLabel,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea,
    useToast
} from "@chakra-ui/react";
import {useFeedback} from "../../store/feedback";
import {useAddNote} from "../../api/moderation";
import {useModal} from "../../store";
// eslint-disable-next-line import/no-cycle
import Notes from "./notes";

const AddNote = styled(({post, comment, onClose}) => {
    const {feedbackCh} = useFeedback();
    const modal = useModal();
    const toast = useToast();
    const author = post ? post.author : comment.author;
    const community = post ? post.community : comment.community;
    const addNote = useAddNote(feedbackCh);
    const [content, setContent] = useState('');
    const handleNote = async () => {
        try {
            await addNote(author, community, content);
            toast({
                title: `Your note has been created for u/${author}!`,
                status: 'success',
                isClosable: true,
            })
        } catch {
            toast({
                title: `Something went wrong when creating your note.`,
                status: 'error',
                isClosable: true,
            })
        }
        modal.open(Notes, {post, comment})
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Create note for /u/{author}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        <FormControl>
                            <FormLabel>Note</FormLabel>
                            <Textarea rows="5" placeholder="" value={content}
                                   onChange={(e) => setContent(e.currentTarget.value)}/>
                        </FormControl>

                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleNote}>Save</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})``;

export default AddNote;
